@if (!hidden && !showUploader) {
  <raised-button [color]="action.actionColor" (click)="handleAction()" [styles]="{ width: '100%' }">
    {{ action.actionText }}
  </raised-button>
}

@if (!hidden && showUploader) {
  <file-uploader
    [buttonText]="action.actionText"
    [buttonColor]="action.actionColor"
    [fileSelected]="action.upload.fileSelected"
    [fileUploaded]="action.upload.fileUploaded"
    [showIcon]="false"
  ></file-uploader>
}
